import React from "react";
import Preloader from "../../helper/Preloader"; 
import FooterOne from "../../components/FooterOne";
import BottomFooter from "../../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import HeaderOneCustomer from "../../componentsAmazon/HeaderOneCustomer";
 import LandingComponent from "../../componentsAmazon/LandingComponent";
const HomePageCustomer = () => {

  return (

    <>

      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#232F3F"  />


      {/* HeaderOneCustomer */}
      <HeaderOneCustomer />
      
 

      {/* LandingComponent */}
      <LandingComponent />
 
 

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default HomePageCustomer;
